/**
 * Function to calculate the absolute page coordinates for where a given dot's tooltip is to be rendered, based on the dot's hitRate and transformed_payoff values.
 * Uses initial sizes defined in theme.js which are scaled up or down depending on current window size.
 * Margins between the div and scatter plot are also taken into account.
 *
 * formula for working out coordinates:
 * x = (div left position on page) + screen horizontal scale factor*(plot margin left + hitRate*(original div width - left and right margins) + tooltip offset x)
 * y = (div top position on page) + (vertical scroll) + screen vertical scale factor*(plot margin top + pay_off*(original div height - top and bottom margins) + tooltip offset y)
 *
 * @param {Object} datum Object containing information about the dot (i.e hitRate, pay_off)
 * @param {Object} graphRef Reference object for the container
 * @param {Object} theme Global theme of the project containing sizing attributes for the plot
 * @returns {{xPos: Number, yPos: Number}} x and y coordinates of the tooltip to be rendered
 */
export function calculateTooltipCoordinates(datum, graphRef, theme) {
    const boundingRect = graphRef.current.getBoundingClientRect();

    const widthScaleFactor =
        boundingRect.width / theme.sizing.scatterPlot.width;
    const heightScaleFactor =
        boundingRect.height / theme.sizing.scatterPlot.height;

    const plotWidth =
        theme.sizing.scatterPlot.width -
        (theme.sizing.scatterPlot.margin.left +
            theme.sizing.scatterPlot.margin.right);
    const plotHeight =
        theme.sizing.scatterPlot.height -
        (theme.sizing.scatterPlot.margin.top +
            theme.sizing.scatterPlot.margin.bottom);

    const xPos =
        boundingRect.x +
        widthScaleFactor *
            (theme.sizing.scatterPlot.margin.left +
                datum.hitRate * plotWidth +
                theme.sizing.tooltip.scatterPlot.offsetX);

    const yPos =
        boundingRect.y +
        window.scrollY +
        heightScaleFactor *
            (theme.sizing.scatterPlot.margin.top +
                (1 - datum.payoffTransformed) * plotHeight +
                theme.sizing.tooltip.scatterPlot.offsetY);

    return { xPos, yPos };
}
